import { generateAPI } from "../api.generator";

export type SkippIdentityData = {
  token: string;
  workspaceId: string;
  expiresAt: number;
};

export const getSkippIdentityToken = generateAPI<{}, SkippIdentityData>(
  "get",
  "user/skipp-identity-token"
);
